import { VariantProps, tv } from "tailwind-variants";

const styles = tv({
  slots: {
    base: "flex h-5 w-full justify-end bg-primary bg-gradient-to-tr from-primary from-[5%] to-green to-[100%]",
    invertedProgress:
      "h-full bg-primary-light transition-all duration-700 ease-in-out",
  },
  variants: {
    rounded: {
      sm: "rounded-sm",
      default: "rounded",
      md: "rounded-md",
      lg: "rounded-lg",
      full: "rounded-full",
    },
  },
});

interface IProps {
  value: number;
  rounded?: VariantProps<typeof styles>["rounded"];
}

const ProgressBar = ({ value, rounded }: IProps) => {
  const { base, invertedProgress } = styles({ rounded });

  const getProgressBarWidth = (value: number) => 100 - value;

  return (
    <div className={base()}>
      <div
        className={invertedProgress()}
        style={{ width: `${getProgressBarWidth(value)}%` }}
      />
    </div>
  );
};

export default ProgressBar;
